import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Icon,
  Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const RenewalsEscalationNotePanel = (props) => {
  return (
    <Accordion className="expansion-panel" defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Icon color="error">error</Icon>
        <Typography className="customer-options">Escalation Note</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>{props.escalation.escalatedNote}</Typography>
      </AccordionDetails>
    </Accordion>
  );
};

RenewalsEscalationNotePanel.propTypes = {
  escalation: PropTypes.object.isRequired
};

export default RenewalsEscalationNotePanel;
